import callApi from './backendService';
import { buildQueryUrlFromObject } from '../../helper/buildQueryUrlFromObject';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}`;

export const getProduct = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/regular-customer-product/${formData.id}`,
  body: formData
});

export const getProducts = (formData) => callApi({
  endpoint: `${basePath}/regular-customer-product?${buildQueryUrlFromObject(formData)}`
});

export const getCategory = () => callApi({
  endpoint: `${basePath}/regular-customer-product/category`
});
